import { StatsCards } from '@/components/dashboard/stats-cards';
import { RevenueChart } from '@/components/dashboard/revenue-chart';
import { PipelineFunnel } from '@/components/dashboard/pipeline-funnel';
import { ActivityFeed } from '@/components/dashboard/activity-feed';

export function DashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Your revenue overview at a glance.</p>
      </div>

      <StatsCards />

      <div className="grid gap-6 lg:grid-cols-2">
        <RevenueChart />
        <PipelineFunnel />
      </div>

      <ActivityFeed />
    </div>
  );
}
